{
    "Accessibility menu": "Přístupnostní menu",
    "Close": "Zavřít",
    "Text and Reading": "Text a čtení",
    "Navigation and Interaction": "Navigace a interakce",
    "Text Align": "Zarovnání textu",
    "Align Left": "Zarovnat vlevo",
    "Align Center": "Zarovnat na střed",
    "Align Right": "Zarovnat vpravo",
    "Adjust Font Size": "Nastavit velikost písma",
    "Highlight Title": "Zvýraznit nadpis",
    "Highlight Links": "Zvýraznit odkazy",
    "Readable Font": "Čitelný font",
    "Color and Contrast": "Barva a kontrast",
    "Dark Contrast": "Tmavý kontrast",
    "Light Contrast": "Světlý kontrast",
    "High Contrast": "Vysoký kontrast",
    "High Saturation": "Vysoká saturace",
    "Low Saturation": "Nízká saturace",
    "Monochrome": "Monochromatický",
    "Tools": "Nástroje",
    "Reading Guide": "Průvodce čtením",
    "Big Cursor": "Velký kurzor",
    "Increase Font Size": "Zvětšit velikost písma",
    "Decrease Font Size": "Zmenšit velikost písma",
    "Letter Spacing": "Mezery mezi písmeny",
    "Line Height": "Výška řádku",
    "Font Weight": "Tloušťka písma",
    "Dyslexia Font": "Dyslexický font",
    "Language": "Jazyk",
    "Accessibility widget": "Otevřít přístupnostní menu",
    "Accessibility Profiles": "Přístupnostní profily",
    "Cognitive Disability": "Kognitivní postižení",
    "Seizure Safe": "Bezpečné pro epilepsii",
    "Accessibility statement": "Prohlášení o přístupnosti",
    "ADHD": "ADHD",
    "Low Vision": "Slabý zrak",
    "Pause Animations": "Zastavit animace",
    "Animation paused": "Animace pozastavena",
    "Reset all settings": "Obnovit nastavení",
    "Shortcut:": "Zkratka:",
    "Epilepsy Safe Mode": "Režim bezpečný pro epilepsii",
    "Mute sounds": "Ztlumit zvuky",
    "Page read": "Číst stránku",
    "Page read controls": "Ovládání čtení stránky",
    "Pause": "Pozastavit",
    "Resume": "Pokračovat",
    "Stop": "Zastavit",
    "Settings": "Nastavení",
    "Speed": "Rychlost",
    "Voice": "Hlas",
    "Close accessibility menu": "Zavřít nabídku přístupnosti",
    "Back to accessibility menu": "Zpět do nabídky přístupnosti",
    "Search languages": "Hledat jazyky",
    "Selected language": "Vybraný jazyk",
    "View accessibility statement (opens in new window)": "Zobrazit prohlášení o přístupnosti (otevře se v novém okně)",
    "Visit CookieYes website (opens in new window)": "Navštívit web CookieYes (otevře se v novém okně)",
    "Reset all accessibility settings to default": "Obnovit všechna nastavení přístupnosti na výchozí"
}
